import type { FC } from 'react';
import { memo, Suspense } from 'react';
import type { DialogProps } from '@mui/material';
import { Dialog, IconButton, Skeleton } from '@mui/material';
import { Close } from '@mui/icons-material';
import CreativeDetailsDialogContent from './CreativeDetailsDialogContent';
import { Box } from '@mui/system';

interface IProps extends DialogProps {
  adId: string;
}

const CreativeDetailsDialogContentSkeleton = () => (
  <Box sx={{ p: 4, display: 'flex', gap: 2, height: '100%' }}>
    <Skeleton variant="rectangular" width="35%" height="100%" />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="60%" height={40} sx={{ mb: 2 }} />
      <Skeleton variant="rectangular" height={200} />
      <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
        <Skeleton variant="rectangular" width={100} height={80} />
        <Skeleton variant="rectangular" width={100} height={80} />
      </Box>
    </Box>
  </Box>
);

const CreativeDetailsDialog: FC<IProps> = memo(({ open, onClose, adId }: IProps) => {
  return (
    <Dialog
      maxWidth={false}
      PaperProps={{
        sx: {
          p: 0,
          width: '90%', // 90% of screen width
          maxWidth: '90%',
          height: '90vh', // Fixed height to ensure scrolling happens inside
          overflowY: 'visible',
        },
      }}
      transitionDuration={{
        appear: 0,
        enter: 0,
        exit: 0,
      }}
      open={open}
      onClose={onClose}
    >
      <Suspense fallback={<CreativeDetailsDialogContentSkeleton />}>
        <CreativeDetailsDialogContent adId={adId} />
      </Suspense>
      <IconButton
        onClick={(e) => {
          if (onClose) {
            onClose(e, 'backdropClick');
          }
        }}
        sx={{
          position: 'absolute',
          top: -12,
          right: -12,
          bgcolor: 'background.paper',
          boxShadow: 2,
          '&:hover': { bgcolor: 'grey.100' },
        }}
      >
        <Close color="action" />
      </IconButton>
    </Dialog>
  );
});

CreativeDetailsDialog.displayName = 'CreativeDetailsDialog';
export default CreativeDetailsDialog;
